import { Component, ViewChild } from '@angular/core';
import { Tab } from './tab.component';
import { NavigationService } from '../service/navigation.service';
import { TabSelectedService } from '../service/tabSelected.service';

@Component( {
    selector: 'tabs',
    template: `
    <ul class="nav nav-tabs">
      <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
        <a href="javascript:void(0)">{{tab.title}}</a>
      </li>
    </ul>
    <ng-content></ng-content>
  `,
    styles: [`
    .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {
        background-color: #31708f !important;
        color: #fff !important;
    }
  `],
    directives: []
} )
export class Tabs {

    public tabs: Tab[];

    constructor( private navigationService: NavigationService, private tabSelectedService: TabSelectedService ) {
        this.tabs = [];
    }

    public selectTab( tab: Tab ): void {
        _deactivateAllTabs( this.tabs );
        tab.active = true;

//        this.tabSelectedService.setActiveTab(tab.name);
        
        function _deactivateAllTabs( tabs: Tab[] ) {
            tabs.forEach(( tab ) => tab.active = false );
        }
    }

    public ngAfterContentChecked(){        
        this.tabSelectedService.setActiveTab(this.getActiveTab());        
    }
    
    private getActiveTab() : string {
        for (let t of this.tabs){
            if (t.active)
                return t.name;
        }
    }

    public selectTabByName( tabName: string ): void {
        let selected = this.tabs.filter(( tab ) => tab.name === tabName );
        if ( selected && selected.length > 0 ) {
            this.selectTab( selected[0] );
        }
    }

    /*_deactivateAllTabs() {
     this.tabs.forEach((tab)=>tab.active = false);
     }*/

    public addTab( tab: Tab ): void {
        if ( this.tabs.length === 0 )
            tab.active = true;
        this.tabs.push( tab );
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/tabs/tabs.component.ts
 **/